'use client';

import dynamic from 'next/dynamic';

export const CssVsJsDemo = dynamic(
  () => import('./CssVsJsDemo/CssVsJsDemo')
);

export const CssVsJsStandalone = dynamic(
  () => import('./CssVsJsDemo/CssVsJsStandalone')
);
